// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export interface ModuleDeadline {
  deadline: number;
}

export interface ItemDeadline {
  deadline: number;
}

export type ScheduleTypeContent = Flexible | Strict;

export interface TimedItemLock {
  unlockTime?: number | null;
  relockTime?: number | null;
  timedItemLockCustomMessage?: string | null;
}

export interface ScheduleOverride {
  timedItemLocks: Record<string, TimedItemLock>;
}

export interface Flexible {
  scheduleOverride?: ScheduleOverride | null;
  enabledForCustomScheduleExperiment?: boolean | null;
}

export interface Strict {
  scheduleOverride?: ScheduleOverride | null;
}

export type ScheduleActivityStatus = 'ACTIVE' | 'INACTIVE' | 'PAUSED';

export interface ModuleDeadlineWithId {
  id: string;
  deadline: number;
}

export interface ItemDeadlineWithId {
  id: string;
  deadline: number;
}

export interface DegreeSession {
  degreeId: string;
}

export interface SessionTypeMetadataDegreeSession {
  typeName: 'degreeSession';
  definition: DegreeSession;
}

export interface CredentialTrackSession {
  degreeId: string;
}

export interface SessionTypeMetadataCredentialTrackSession {
  typeName: 'credentialTrackSession';
  definition: CredentialTrackSession;
}

export type SessionTypeMetadata = SessionTypeMetadataDegreeSession | SessionTypeMetadataCredentialTrackSession;

export type SessionTypeMetadataTypeName = 'degreeSession' | 'credentialTrackSession';

export interface LearnerCourseScheduleComputationMetadata {
  sessionId: string;
  courseId: string;
  branchId: string;
  versionedBranchId?: string | null;
  enrollmentEndsAt?: number | null;
  isPreview?: boolean | null;
  isPrivate: boolean;
  isContentExperiment: boolean;
  discussionSessionId?: string | null;
  sessionTypeMetadata?: SessionTypeMetadata | null;
}

export interface LearnerCourseSchedulesV1 {
  id: string;
  userId: number;
  courseId: string;
  startsAt: number;
  endsAt: number;
  moduleDeadlines: Record<string, ModuleDeadline>;
  itemDeadlines: Record<string, ItemDeadline>;
  scheduleTypeContent: ScheduleTypeContent;
  scheduleActivityStatus: ScheduleActivityStatus;
  mostRecentDeadlineChangeTime?: number | null;
  moduleDeadlinesArray?: Array<ModuleDeadlineWithId> | null;
  itemDeadlinesArray?: Array<ItemDeadlineWithId> | null;
  computationMetadata: LearnerCourseScheduleComputationMetadata;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface LearnerCourseSchedulesV1Connection {
  elements: Array<LearnerCourseSchedulesV1> | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface LearnerCourseSchedulesV1DeleteQuery {
  LearnerCourseSchedulesV1: {
    delete: LearnerCourseSchedulesV1Connection | null;
  } | null;
}

export interface LearnerCourseSchedulesV1DeleteQueryVariables {
  id: string;
  includes?: string | null;
}

export interface LearnerCourseSchedulesV1FindBySlugQuery {
  LearnerCourseSchedulesV1: {
    findBySlug: LearnerCourseSchedulesV1Connection | null;
  } | null;
}

export interface LearnerCourseSchedulesV1FindBySlugQueryVariables {
  slug: string;
  includes?: string | null;
}

export interface LearnerCourseSchedulesV1GetQuery {
  LearnerCourseSchedulesV1: {
    get: LearnerCourseSchedulesV1Connection | null;
  } | null;
}

export interface LearnerCourseSchedulesV1GetQueryVariables {
  id: string;
  includes?: string | null;
}

export interface LearnerCourseSchedulesV1MultiGetQuery {
  LearnerCourseSchedulesV1: {
    multiGet: LearnerCourseSchedulesV1Connection | null;
  } | null;
}

export interface LearnerCourseSchedulesV1MultiGetQueryVariables {
  ids: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-link mutations
// ========================================================================

export interface LearnerCourseSchedulesV1AdjustMutation {
  LearnerCourseSchedulesV1: {
    adjust: LearnerCourseSchedulesV1Connection | null;
  } | null;
}

export interface LearnerCourseSchedulesV1AdjustMutationVariables {
  id: string;
  includes?: string | null;
}

export interface LearnerCourseSchedulesV1CreateMutation {
  LearnerCourseSchedulesV1: {
    create: LearnerCourseSchedulesV1Connection | null;
  } | null;
}

export interface LearnerCourseSchedulesV1CreateMutationVariables {
  includes?: string | null;
}

export interface LearnerCourseSchedulesV1InvalidateCacheMutation {
  LearnerCourseSchedulesV1: {
    invalidateCache: LearnerCourseSchedulesV1Connection | null;
  } | null;
}

export interface LearnerCourseSchedulesV1InvalidateCacheMutationVariables {
  userId: string;
  courseId: string;
  includes?: string | null;
}

export interface LearnerCourseSchedulesV1LagMutation {
  LearnerCourseSchedulesV1: {
    lag: LearnerCourseSchedulesV1Connection | null;
  } | null;
}

export interface LearnerCourseSchedulesV1LagMutationVariables {
  id: string;
  includes?: string | null;
}

export interface LearnerCourseSchedulesV1PreviewScheduleMutation {
  LearnerCourseSchedulesV1: {
    previewSchedule: LearnerCourseSchedulesV1Connection | null;
  } | null;
}

export interface LearnerCourseSchedulesV1PreviewScheduleMutationVariables {
  userId: string;
  courseId: string;
  includes?: string | null;
}

export interface LearnerCourseSchedulesV1RecomputeEndDateMutation {
  LearnerCourseSchedulesV1: {
    recomputeEndDate: LearnerCourseSchedulesV1Connection | null;
  } | null;
}

export interface LearnerCourseSchedulesV1RecomputeEndDateMutationVariables {
  userId: string;
  courseId: string;
  includes?: string | null;
}

export interface LearnerCourseSchedulesV1UpdateScheduleForUserLevelGoalsMutation {
  LearnerCourseSchedulesV1: {
    updateScheduleForUserLevelGoals: LearnerCourseSchedulesV1Connection | null;
  } | null;
}

export interface LearnerCourseSchedulesV1UpdateScheduleForUserLevelGoalsMutationVariables {
  userId: string;
  courseId: string;
  includes?: string | null;
}

export interface LearnerCourseSchedulesV1UpdateScheduleWithLearnerGoalMutation {
  LearnerCourseSchedulesV1: {
    updateScheduleWithLearnerGoal: LearnerCourseSchedulesV1Connection | null;
  } | null;
}

export interface LearnerCourseSchedulesV1UpdateScheduleWithLearnerGoalMutationVariables {
  userId: string;
  courseId: string;
  includes?: string | null;
}

export interface LearnerCourseSchedulesV1UpdateStoredPersonalizedScheduleMutation {
  LearnerCourseSchedulesV1: {
    updateStoredPersonalizedSchedule: LearnerCourseSchedulesV1Connection | null;
  } | null;
}

export interface LearnerCourseSchedulesV1UpdateStoredPersonalizedScheduleMutationVariables {
  id: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
      ? PartialConstruction<T[TKey]>
      : T[TKey];
};

export class LearnerCourseSchedulesV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'learnerCourseSchedules.v1' as const;

  declare id: string;

  declare userId: number;

  declare courseId: string;

  declare startsAt: number;

  declare endsAt: number;

  declare moduleDeadlines: Record<string, ModuleDeadline>;

  declare itemDeadlines: Record<string, ItemDeadline>;

  declare scheduleTypeContent: ScheduleTypeContent;

  declare scheduleActivityStatus: ScheduleActivityStatus;

  declare mostRecentDeadlineChangeTime?: number | null;

  declare moduleDeadlinesArray?: Array<ModuleDeadlineWithId> | null;

  declare itemDeadlinesArray?: Array<ItemDeadlineWithId> | null;

  declare computationMetadata: LearnerCourseScheduleComputationMetadata;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<LearnerCourseSchedulesV1>) {
    super(params);
  }
}
